export const checkStringHasSymbol = (string, symbol) => new RegExp("\\" + symbol).test(string);